export default 'APP_STARTUP';
